import { Link } from "react-router-dom";
import { ChevronRight, Search, Sofa, Leaf, Recycle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HERO_IMAGE } from "@/mock";

export default function Hero() {
  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt="Servicio de recogida" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#16281F]/95 via-[#2F5B49]/88 to-[#3f6a53]/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 w-full">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
            Ayuntamiento de San Fernando de Henares &amp; Valoriza
          </span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-5" data-testid="hero-title">
            San Fernando de Henares, recicla y reduce
          </h1>
          <div className="text-white/90 text-base sm:text-lg leading-relaxed mb-10 max-w-xl space-y-1" data-testid="hero-tagline">
            <p className="font-semibold">Recogida de Enseres y Poda en tu isla de contenedores más cercana.</p>
            <p className="font-semibold">Punto Limpio Móvil. Todos los sábados.</p>
            <p>Juntos/as vamos a reciclar mejor.</p>
          </div>

          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <Link to="/solicitud">
              <Button
                size="lg"
                className="whitespace-normal text-center shrink-0 bg-municipal hover:bg-municipal-dark text-white font-semibold text-base px-8 h-14 shadow-lg"
                data-testid="hero-solicitar-btn"
              >
                Solicitar Recogida de Enseres y/o Poda <ChevronRight className="w-5 h-5 ml-1" />
              </Button>
            </Link>
            <Link to="/punto-limpio">
              <Button
                size="lg"
                className="shrink-0 bg-white hover:bg-gray-100 text-[#2F5B49] font-semibold text-base px-8 h-14 shadow-lg"
                data-testid="hero-puntolimpio-btn"
              >
                <Recycle className="w-5 h-5 mr-2" /> Punto Limpio Móvil
              </Button>
            </Link>
            <Link to="/consultar">
              <Button
                size="lg"
                variant="outline"
                className="shrink-0 border-white/40 text-white hover:bg-white/10 hover:text-white h-14 px-8 text-base bg-transparent"
                data-testid="hero-consultar-btn"
              >
                <Search className="w-5 h-5 mr-2" /> Consultar mi ticket
              </Button>
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-3 mt-10">
            <div className="flex items-center gap-2.5 bg-white/15 backdrop-blur-sm rounded-full pl-2 pr-4 py-2 text-white" data-testid="hero-badge-enseres">
              <div className="w-8 h-8 rounded-full bg-municipal flex items-center justify-center shrink-0"><Sofa className="w-4 h-4" /></div>
              <span className="text-sm font-semibold">Lun / Mié / Vie — Enseres y Poda</span>
            </div>
            <div className="flex items-center gap-2.5 bg-white/15 backdrop-blur-sm rounded-full pl-2 pr-4 py-2 text-white" data-testid="hero-badge-poda">
              <div className="w-8 h-8 rounded-full bg-municipal flex items-center justify-center shrink-0"><Leaf className="w-4 h-4" /></div>
              <span className="text-sm font-semibold">Mar / Jue — Poda</span>
            </div>
            <div className="flex items-center gap-2.5 bg-white/15 backdrop-blur-sm border border-white/30 rounded-full pl-2 pr-4 py-2 text-white" data-testid="hero-badge-puntolimpio">
              <div className="w-8 h-8 rounded-full bg-municipal flex items-center justify-center shrink-0"><Recycle className="w-4 h-4" /></div>
              <span className="text-sm font-semibold">Sábados — Punto Limpio Móvil</span>
            </div>
          </div>

          <a href="tel:916751810" className="inline-flex items-center gap-2 bg-municipal hover:bg-municipal-dark text-white text-sm font-semibold px-4 py-3 rounded-xl mt-6 mb-2 shadow-lg transition-colors max-w-full" data-testid="hero-atencion-mayores-link">
            <Phone className="w-4 h-4 shrink-0" /> Más información y atención a personas mayores: <strong className="font-bold whitespace-nowrap">916 75 18 10</strong>
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
